import { render, staticRenderFns } from "./DataGroups.vue?vue&type=template&id=b97f3d6a&scoped=true"
import script from "./DataGroups.vue?vue&type=script&lang=js"
export * from "./DataGroups.vue?vue&type=script&lang=js"
import style0 from "./DataGroups.vue?vue&type=style&index=0&id=b97f3d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97f3d6a",
  null
  
)

export default component.exports